<template>
    <b-container>
        <h3 :class="getLanguageItem['IconPanelWelcome']['titleClass']">
            {{ getLanguageItem['IconPanelWelcome']['title'] }}
        </h3>
        <div :class="getLanguageItem['IconPanelWelcome']['subTitleClass']" v-if="getLanguageItem['IconPanelWelcome']['subTitleClass'] !=''">
            {{ getLanguageItem['IconPanelWelcome']['subTitle'] }}
        </div>
        <b-row>
            <b-col  v-for="IconPanelItem in getIcons" :key="IconPanelItem.id"
                    :lg="IconPanelItem.lg" :md="IconPanelItem.md" :sm="IconPanelItem.sm" :xs="IconPanelItem.xs" 
                    :class="IconPanelItem.colClass">
                
                <img    :src="IconPanelItem.image" alt="" 
                        :width="IconPanelItem.imageWidth">

            <div :class="IconPanelItem.textClass">
                {{ IconPanelItem.text }}
            </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'ShopIconPanel',
    computed: {
        getLanguageItem: function() { 
            return this.$store.getters.getLanguageStrings;
        },
        getIcons: function() {
            return this.$store.getters.getLanguageStrings['IconPanelWelcome']['icons'];
        }
    },
    mounted() {
    
    //console.log(this.getIcons);
  }
}
</script>
